module.exports = __webpack_public_path__ + "img/single-gene-report.b403038c.png";